import {Button, ButtonGroup} from '@/components/atoms'
import React from 'react'

interface SaveCancelFooterProps {
  handleCancel: () => void
  draftAction: () => void
  nextAction: () => void
  isReview?: boolean
  hideSaveDraft?: boolean
  FormError?: boolean
  isLoading?: boolean
  isSaveDraftDisabled: boolean
}

const SaveCancelFooter: React.FC<SaveCancelFooterProps> = ({
  handleCancel,
  draftAction,
  nextAction,
  isReview = false,
  hideSaveDraft = false,
  FormError = false,
  isLoading = false,
  isSaveDraftDisabled = false,
}) => {
  const saveDraftSchema = () => {
    if (hideSaveDraft) {
      return [
        {
          label: 'Cancel',
          onClick: handleCancel,
        },
      ]
    } else {
      return [
        {
          label: 'Cancel',
          onClick: handleCancel,
        },
        {
          label: 'Save Draft',
          onClick: draftAction,
          disabled: isSaveDraftDisabled,
        },
      ]
    }
  }

  return (
    <div className="flex justify-between py-4">
      <ButtonGroup
        //@ts-expect-error fix later
        className="$color-button $color-button-secondary dark"
        uiSchema={{
          items: saveDraftSchema(),
        }}
      />
      <Button
        key={`next-btn-${FormError ? 'disabled' : 'enabled'}`}
        handleButton={nextAction}
        uiSchema={{
          className: 'ml-4',
          title: isReview ? 'Publish' : 'Next',
          variant: 'primary',
          size: 'medium',
          iconTrailing: 'arrow_forward',
          disabled: FormError,
          isLoading,
        }}
      />
    </div>
  )
}

export default SaveCancelFooter
